module.exports = __webpack_public_path__ + "img/logo-chullagol.48c6f224.png";